export const space = [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 56, 64, 72, 80, 120, 160]
